<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig" />
    <editor :config="{id: gridConfig.id, api: 'Payments/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'PaymentsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Payments' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
